"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return Array.isArray(value);
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isArray.js
// module id = 648
// module chunks = 0